<template lang="html">
  <div class="ui-choose-wrapper">
    <div class="ui-address-choose-group" v-show="showTitle">
      <span
        class="ui-address-choose-group-item"
        :class="{ hover: show === 0 }"
        @click="toggle(0)"
        >{{ province }}</span
      >
      <span
        class="ui-address-choose-group-item"
        :class="{ hover: show === 1 }"
        @click="toggle(1)"
        >{{ city }}</span
      >
      <span
        class="ui-address-choose-group-item"
        :class="{ hover: show === 2 }"
        @click="toggle(2)"
        v-show="!twoSelect"
        >{{ district }}</span
      >
    </div>
    <div
      class="ui-address-choose"
      :class="{ chooseHover: show === 0, 'title-hide': !showTitle }"
    >
      <ul class="ui-address-choose-select">
        <li
          class="ui-address-choose-select-item"
          :class="{ hover: province === item.NAME }"
          v-for="item in proList"
          @click="getCity(item, 1, $event)"
        >
          {{ item.NAME }}
        </li>
      </ul>
    </div>
    <div
      class="ui-address-choose"
      :class="{ chooseHover: show === 1, 'title-hide': !showTitle }"
    >
      <ul class="ui-address-choose-select">
        <li
          class="ui-address-choose-select-item"
          :class="{ hover: city === item.NAME }"
          v-for="item in cityList"
          @click="getDistrict(item, 2, $event)"
        >
          {{ item.NAME }}
        </li>
      </ul>
    </div>
    <div
      class="ui-address-choose"
      :class="{ chooseHover: show === 2, 'title-hide': !showTitle }"
      v-show="!twoSelect"
    >
      <ul class="ui-address-choose-select">
        <li
          class="ui-address-choose-select-item"
          :class="{ hover: district === item.NAME }"
          v-for="item in districtList"
          @click="getAll(item, 3, $event)"
        >
          {{ item.NAME }}
        </li>
      </ul>
    </div>
    <toast v-if="toastShow" v-model="toastShow">
      <slot>{{ toastText }}</slot>
    </toast>
  </div>
</template>

<script>
import jsCookie from 'js-cookie'
import fetch from '@/plugins/fetch'
import queryString from 'query-string'

import toast from './toast'

export default {
  props: {
    placeholder: {}, // TODO
    districtId: {
      type: String,
      default: '320102'
    },
    chooseIsShow: {
      type: Boolean,
      default: false
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    // 选择省市
    twoSelect: {
      type: Boolean,
      default: false
    },
    cityID: {
      type: String,
      default: '320100'
    }
  },
  components: {
    toast
  },
  data() {
    return {
      api: '',
      proList: [],
      cityList: [],
      districtList: [],
      province: '',
      city: '',
      district: '',
      regionid: [],
      show: 0,
      toastShow: false,
      toastText: '抱歉，系统异常'
    }
  },
  computed: {
    provinceId() {
      if (this.twoSelect) {
        return `${this.cityID.slice(0, 2)}0000`
      } else {
        return `${this.districtId.slice(0, 2)}0000`
      }
    },
    cityId() {
      if (this.twoSelect) {
        return this.cityID
      } else {
        return `${this.districtId.slice(0, 4)}00`
      }
    }
  },
  watch: {
    // cityId() {
    //     this.init()
    // },
    districtId() {
      this.init()
    },
    chooseIsShow() {
      this.scrollToHover()
    },
    show() {
      this.scrollToHover()
    }
  },
  methods: {
    hostname(prefix = '') {
      const hn = location.hostname
      return hn.indexOf('haiziwang.com') > -1
        ? `//${prefix}.haiziwang.com`
        : `//${prefix}.cekid.com`
    },
    toggle(index) {
      this.show = index
    },
    scrollToHover() {
      this.$nextTick(() => {
        const el = document.querySelector('.chooseHover .hover')
        const offsetTop = el.offsetTop
        document.querySelector('.chooseHover').scrollTop = offsetTop
      })
    },
    async getPro() {
      try {
        const url = `${this.api.pro}`
        const res = await fetch(url)
        const json = await res.json()
        if (json.ProvinceList && json.ProvinceList.length) {
          this.proList = json.ProvinceList
          this.proList.forEach(v => {
            if (v.ID === this.provinceId) {
              this.province = v.NAME
            }
          })
          this.scrollToHover()
        } else {
          this.toastShow = true
          this.toastText = '抱歉，地址接口异常'
        }
      } catch (e) {
        console.log(e)
        this.toastShow = true
        this.toastText = '抱歉，系统异常'
      }
    },
    async getCity(item, index) {
      try {
        const url = `${this.api.city}`
        const param = queryString.stringify({
          provinceId: (item && item.ID) || this.provinceId
        })
        const res = await fetch(`${url}?${param}`)
        const json = await res.json()
        if (json.CityList && json.CityList.length) {
          this.cityList = json.CityList
          this.cityList.forEach(v => {
            if (v.ID === this.cityId) {
              this.city = v.NAME
            }
          })
          if (item) {
            this.show = index
            this.province = item.NAME
            this.regionid[0] = item.ID
            this.city = this.cityList[0].NAME
            if (!this.twoSelect) {
              this.getDistrict(this.cityList[0], 1)
            }
          } else {
            this.regionid[0] = this.provinceId
          }
          if (this.twoSelect) {
            this.sendMsg(index)
          }
        } else {
          this.toastShow = true
          this.toastText = '抱歉，地址接口异常'
        }
      } catch (e) {
        console.log(e)
        this.toastShow = true
        this.toastText = '抱歉，系统异常'
      }
    },
    async getDistrict(item, index) {
      try {
        const url = `${this.api.district}`
        const param = queryString.stringify({
          cityId: (item && item.ID) || this.cityId
        })
        const res = await fetch(`${url}?${param}`)
        const json = await res.json()
        if (json.DistrictList && json.DistrictList.length) {
          this.districtList = json.DistrictList
          this.districtList.forEach(v => {
            if (v.ID === this.districtId) {
              this.district = v.NAME
            }
          })
          if (item) {
            this.show = index
            this.city = item.NAME
            this.regionid[1] = item.ID
            this.district = this.districtList[0].NAME
          } else {
            this.regionid[1] = this.cityId
          }
          this.sendMsg(index)
        } else {
          this.toastShow = true
          this.toastText = '抱歉，地址接口异常'
        }
      } catch (e) {
        console.log(e)
        this.toastShow = true
        this.toastText = '抱歉，系统异常'
      }
    },
    getAll(item, index) {
      this.district = item.NAME
      this.regionid[2] = item.ID
      this.sendMsg(index)
    },
    sendMsg(index) {
      let regionid
      if (this.regionid[2] && !this.twoSelect) {
        regionid = this.regionid.join('_')
      } else {
        regionid = `${this.provinceId}_${this.cityId}_${this.districtId}`
      }
      let hasOver = index === 3
      if (this.twoSelect) {
        hasOver = index === 2
      }
      this.$emit('input', {
        over: hasOver,
        province: this.province,
        city: this.city,
        district: this.district,
        regionid
      })
    },
    init() {
      this.getPro()
      this.getCity()
      if (!this.twoSelect) {
        this.getDistrict()
      }
    }
  },
  created() {
    const addressUrl = `${this.hostname('address')}/addressview`
    this.api = {
      pro: `${addressUrl}/GetProvinceList`,
      city: `${addressUrl}/GetCityList`,
      district: `${addressUrl}/GetDistrictList`
    }
    this.init()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/mixin';
.ui-choose-wrapper {
  position: relative;
  height: 100%;
}
.ui-address-choose {
  position: absolute;
  left: 0;
  top: rem(80px);
  right: 0;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #fff;
  -webkit-overflow-scrolling: touch;
  display: none;

  .ui-address-choose-select {
    .ui-address-choose-select-item {
      padding-left: rem(25px);
      font-size: rem(30px);
      line-height: rem(80px);
      &.hover {
        color: #ff397e;
      }
    }
  }

  &.chooseHover {
    display: block;
  }
  &.title-hide {
    top: 0;
  }
}
.ui-address-choose-group {
  display: flex;
  font-size: rem(30px);
  line-height: rem(80px);
  text-align: center;
  .ui-address-choose-group-item {
    @include border(bottom);
    flex: 1;
    &.hover {
      color: #ff397e;
      &::before {
        border-bottom: 1px solid #ff397e;
      }
    }
  }
}
</style>
